import { useCallback, useState } from "react";
import { getCurrentLocation, type ILocationFix } from "@/utils/geolocation";

/**
 * Request the device location on demand (see getCurrentLocation), tracking
 * whether a request is in flight so the triggering button can show progress.
 *
 * `locate` resolves to null instead of rejecting: callers send a null location
 * and let the server's rules decide whether that blocks the action.
 */
export const useCurrentLocation = () => {
  const [isLocating, setIsLocating] = useState(false);

  const locate = useCallback(async (): Promise<ILocationFix | null> => {
    setIsLocating(true);
    try {
      return await getCurrentLocation();
    } catch {
      return null;
    } finally {
      setIsLocating(false);
    }
  }, []);

  return { locate, isLocating };
};
